import React from 'react';
import LinkTable from '../components/LinkTable';

function LibraryPage({
  links,
  formResponses,
  itemFormResponses,
  orders,
  interactions,
  activeLinkId,
  error,
  isCreating,
  isSignedIn,
  user,
  onSelectLink,
  onCreateLink,
  onDeleteLink,
  onDuplicateLink,
  onItemFormResponseChange,
  onNavigate,
  onOrderChange,
  onStatusChange,
  onSubmissionDelete,
}) {
  const totalAssets = links.reduce((sum, link) => sum + (link.assets?.length || 0), 0);
  const totalViews = links.reduce((sum, link) => sum + (link.views || 0), 0);
  const totalShares = links.reduce((sum, link) => sum + (link.shares || 0), 0);

  return (
    <section className="mx-auto max-w-7xl px-5 py-6 sm:px-8">
      <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="label-caps">Library</p>
          <h1 className="mt-2 text-3xl font-semibold tracking-normal">Created links</h1>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
            Manage branded asset links for documents, personal albums, product catalogs, and controlled galleries.
          </p>
        </div>
        <button
          className="rounded bg-slate-950 px-4 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:bg-slate-300"
          disabled={isCreating}
          onClick={onCreateLink}
          type="button"
        >
          {isCreating ? 'Creating...' : 'New asset link'}
        </button>
      </div>

      {!isSignedIn && (
        <div className="mb-5 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          Sign in or create an account before creating Firestore-backed asset links.
        </div>
      )}

      {error && (
        <div className="mb-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <div className="mb-5 grid grid-cols-4 gap-2 sm:gap-4">
        <div className="stat-card">
          <span>Links</span>
          <strong>{links.length}</strong>
        </div>
        <div className="stat-card">
          <span>Assets</span>
          <strong>{totalAssets}</strong>
        </div>
        <div className="stat-card">
          <span>Views</span>
          <strong>{totalViews}</strong>
        </div>
        <div className="stat-card">
          <span>Shares</span>
          <strong>{totalShares}</strong>
        </div>
      </div>

      <LinkTable
        links={links}
        activeLinkId={activeLinkId}
        onSelect={(id) => {
          if (onSelectLink(id) !== false) {
            onNavigate('create');
          }
        }}
        formResponses={formResponses}
        itemFormResponses={itemFormResponses}
        orders={orders}
        interactions={interactions}
        isCreating={isCreating}
        user={user}
        onDelete={onDeleteLink}
        onDuplicate={onDuplicateLink}
        onItemFormResponseChange={onItemFormResponseChange}
        onOrderChange={onOrderChange}
        onStatusChange={onStatusChange}
        onSubmissionDelete={onSubmissionDelete}
      />
    </section>
  );
}

export default LibraryPage;
